<script setup lang="ts">
import type { Component, HTMLAttributes } from 'vue';

import {
  DropdownMenuItem,
  DropdownMenuLabel
} from '@/components/ui/DropdownMenu';

import { cn } from '@/lib/utils';

const props = withDefaults(
  defineProps<{
    class?: string;
    itemIcon?: Component | string;
    itemClass?: HTMLAttributes['class'];
    testId?: string;
    itemLabel: string;
  }>(),
  {
    testId: 'custom-dropdown-menu'
  }
);
</script>

<template>
  <DropdownMenuItem
    :test-id="props.testId"
    :class="cn('pl-0', props.itemIcon && 'pl-2', props.class)"
  >
    <component
      :is="itemIcon"
      :class="cn('w-4 h-4', itemClass)"
      stroke-width="1.5"
    />
    <DropdownMenuLabel>{{ itemLabel }}</DropdownMenuLabel>
    <slot></slot>
  </DropdownMenuItem>
</template>
